import React, { Component } from 'react';
import {connect} from 'react-redux';
import __ from 'lodash';
import {cekCookies} from '../../../../actions';
import { CONFIG } from '../../../../config';
import Navbar from '../../navbar/Navbar';
import Sidebar from '../../sidebar/Sidebar';
import LoaderModal from '../../../modal/LoaderModal';
import accountManagement from '../../../../apis/accountManagement';

import Loader from '../../../Loader';


class Aktivitasuphis extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            isFetching: false,
            loading: false,
            dataGuru : [],
            dataUphis : []
        }
    }

    async componentDidMount() {
        document.title = "Aktivitas Upload Histori";
        this.setState({
            isFetching: true
        });
        await this.props.cekCookies();

        if(!__.isEmpty(this.props.account)) {
            this.fetchUpHisSekolah();
        }

        this.setState({
            isFetching: false
        });
    }

    fetchUpHisSekolah = async () =>{
        this.setState({loading: true});

        //fetch upload histori yg dilakukan oleh guru sekolah
        const resData = await accountManagement.get(CONFIG.FETCH_UPHIS_GURU_SEKOLAH).catch(function(error){
        })
        if(resData){
            if(resData.data.errorSchema.errorCode === CONFIG.SUCCESS_ERROR_CODE){
                this.setState({
                    dataUphis: resData.data.data.dataUpHis,
                    dataGuru: resData.data.data.dataGuru,
                })
            }
        }
        this.setState({loading: false});
    }

    renderParent(){
        if(!__.isEmpty(this.state.dataGuru)){
            return this.state.dataGuru.map((val,i) => {
                return (

                    <div id="accordion"> 
                        <div className="card" style={{marginBottom: '5px'}} >
                            <div className="card-header">                    
                                <div className="row">
                                    <div className="col-sm-12 col-xs-12">
                                        <div className="row">
                                            <div className="col-sm-12 col-xs-12">
                                                <a className="card-link" data-toggle="collapse" href={'#child'+val.idGuru}>
                                                {val.namaGuru} <i className="fa fa-angle-down" aria-hidden="true" ></i>
                                                </a>
                                            </div>   
                                        </div>
                                    </div>
                                </div>
                            </div> 
                            { this.renderTableChild(val.idGuru, i) }                   
                        </div>   
                    </div>
                )
            })
        }
    }

    renderTableChild(id, i){
        return(
            <div id={'child'+id} class="panel-collapse collapse" data-parent="#accordion">
                <table class="table table">
                    <thead>
                        <tr>
                            <th key={i+1}>No</th>
                            <th key={i+2}>Nama Upload Histori</th>
                            <th key={i+3}>Tgl Upload</th>
                            <th key={i+4}>Jumlah soal</th>
                        </tr>
                    </thead>
                    <tbody>
                        {this.renderChild(id)}
                    </tbody>
                </table>
            </div>
        )
    }

    renderChild(id){
        var n=1;
        if(!__.isEmpty(this.state.dataUphis)){
            return this.state.dataUphis.map((valChild,j) => {
                if(id===valChild.idGuru){
                    return (
                        <tr>
                            <td key={j+1}>{n++}</td>
                            <td key={j+2}>{valChild.keterangan}</td>
                            <td key={j+3}>{valChild.tglUpload}</td>
                            <td key={j+4}>{valChild.jumSoal}</td>
                        </tr>
                    )
                }                
            })
        }
    }

    render() {
        return (
            <div className="wrapper">
                <LoaderModal isFetching={this.state.isFetching} />
                <Sidebar account={this.props.account}/>
                <div id="content" style={{paddingBottom: '50px'}}>
                    <Navbar />
                    <br></br>
                    {this.loading()}
                    {this.renderParent()}
                    <br></br>
                    {this.loading()}
                </div>
            </div>
        )
    }


    loading = () =>{
        if(this.state.loading){
            return(
                <Loader />
            )
        }
    }
}
const mapStateToProps = (state) => {
    return {
        account: state.account
    };
}

export default connect(mapStateToProps, {cekCookies})(Aktivitasuphis)
